import { render, staticRenderFns } from "./DialogAssignCard.vue?vue&type=template&id=3671678e&scoped=true&"
import script from "./DialogAssignCard.vue?vue&type=script&lang=js&"
export * from "./DialogAssignCard.vue?vue&type=script&lang=js&"
import style0 from "./DialogAssignCard.vue?vue&type=style&index=0&id=3671678e&prod&lang=scss&scoped=true&"
import style1 from "./DialogAssignCard.vue?vue&type=style&index=1&id=3671678e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671678e",
  null
  
)

export default component.exports